const awsConfig = {
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    region: "eu-west-2",
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    usernameAttributes: "email",
  },
  oauth: {
    domain: process.env.REACT_APP_COGNITO_DOMAIN,
    redirectSignIn: {
      local: process.env.REACT_APP_LOCAL_URL,
      deployed: process.env.REACT_APP_DEPLOYED,
    },
    redirectSignOut: {
      local: process.env.REACT_APP_LOCAL_URL,
      deployed: process.env.REACT_APP_DEPLOYED,
    },
    responseType: "token",
    scope: ["email", "phone", "openid", "profile"],
  },
};

export default awsConfig;
